
export const getShieldNameFromSeed = (seed: number, stars: number) => {
  if(seed === -1 && stars === -1) // TEMP anti lint
    return 'Templars will';
  return 'Templars will';
};
